import { RegExpUtility } from "../../text/RegExpUtility";

export class EditingKeys
{
  static readonly Backspace = "Backspace";
  static readonly Clear = "Clear";
  static readonly Copy = "Copy";
  static readonly CrSel = "CrSel";
  static readonly Cut = "Cut";
  static readonly Delete = "Delete";
  static readonly EraseEof = "EraseEof";
  static readonly ExSel = "ExSel";
  static readonly Insert = "Insert";
  static readonly Paste = "Paste";
  static readonly Redo = "Redo";
  static readonly Undo = "Undo";


  // matcher: static readonly (\w+) = "\w+";
  // replace: EditingKeys.$1,

  static readonly keys:string[] = 
  [
    EditingKeys.Backspace,
    EditingKeys.Clear,
    EditingKeys.Copy,
    EditingKeys.CrSel,
    EditingKeys.Cut,
    EditingKeys.Delete,
    EditingKeys.EraseEof,
    EditingKeys.ExSel,
    EditingKeys.Insert,
    EditingKeys.Paste,
    EditingKeys.Redo,
    EditingKeys.Undo
  ];

  static readonly regex:RegExp = RegExpUtility.createMatcherFromCombiningWords( EditingKeys.keys, true );
  
  static is( key:string )
  {
    return this.regex.test( key );
  }
}